import { z } from 'zod'

export const schema = z.object({
  email: z.email(),
  password: z.string().min(1),
})

export type Schema = z.infer<typeof schema>

export const schemaDefaults: Schema = {
  email: '',
  password: '',
}
